import React from 'react'
import { motion } from 'framer-motion'
import { images } from '../../constants'
import './Header.scss'
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper'

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      durationL: 1,
      ease: 'easeInOut'
    }
  }
}

const textMotion = {
  hover: {
    rotate: 45,
  }
};

const Header = () => {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Hello, I am</p>
              <h1 className="head-text">Ignacio</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">Software engineer</p>
            <p className="p-text">&</p>
            <p className="p-text">web developer</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileHover="hover"
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-img"
      >
        <motion.img 
          src={images.developer} 
          // style={{ borderRadius: "100%" }} 
          alt="profile_bg"
          className="profile_icon"
        >
          
        </motion.img>
        <motion.img
          whileInView={{ scale: [0, 1], rotate: 360 }}
          transition={{ duration: 1, ease: 'easeInOut'}}
          src={images.setting}
          alt="profile_setting"
          className="overlay_setting"
          variants={textMotion}
        >
        </motion.img>
      </motion.div>
      
      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {[images.typescript, images.react, images.javascript].map(circle => (
          <div className="circle-cmp app__flex" key={`circle-${circle}`} onClick={() => window.location.hash = 'skills'}>
            <img src={circle} alt="circle"/>
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default SectionWrapper(Header, 'home', 'app__primarybg')